import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Router } from "@angular/router";
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AlertService } from '../shared/services/alert.service';
import { Utils } from './utils';
import { AuthService } from '../main';
import { JwTokenModel } from './api/models';
import { MiniProfilerService } from './services/mini-profiler.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private router: Router,

    private alertService: AlertService,
    
    private authService: AuthService,
    private http: HttpClient,
    private profiler: MiniProfilerService
    
  ) { }
   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // add authorization header with jwt token if available
    var isAPIRequest = request.url.startsWith(environment.webApiRoot +'/api/');

    if (isAPIRequest
      && this.authService.tokenInfo
      && this.authService.tokenInfo.expires_at) {

      if (new Date(this.authService.tokenInfo.expires_at) < new Date()) {
        // Token is expired, try to refresh it if possible

        const tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') || '{}') as JwTokenModel;
        if (tokenInfo.access_token && tokenInfo.access_token != this.authService.tokenInfo?.access_token) {
          this.authService.tokenInfo$.next(tokenInfo);
        }
        else if (this.authService.tokenInfo?.refresh_token
          && this.authService.tokenInfo?.refresh_expires_at
          && new Date(this.authService.tokenInfo.refresh_expires_at) > new Date()) {

            
          if (!request.url.startsWith(environment.webApiRoot + '/api/Account/RefreshToken'))
          {
            if (!localStorage.getItem('refreshingToken'))
               this.authService.getTokenInfo().forEach(token => {
                 console.debug('Token Refreshed', token?.expires_at);
                localStorage.removeItem('refreshingToken');
               });
            return throwError({ Message: 'Refreshing authentication token. Try again' });
          }
        } 
        else if (!request.url.startsWith(environment.webApiRoot + '/api/Account/')
          && !request.url.startsWith(environment.webApiRoot + '/api/HealthCheck/'))
        {
          // Token is expired and cannot be refreshed, sign out the user

          localStorage.removeItem('tokenInfo');
          this.authService.tokenInfo$.next(tokenInfo);
          return throwError({ Message: 'Authentication token expired. Please sign in again.' });
        }
      }
      
      request = request.clone({
        setHeaders: {
          Authorization:
            this.authService.isSignedIn() ? `Bearer ${this.authService.tokenInfo?.access_token}` : ''
          //'x-api-version': `${environment.apiServer.apiVersion}`
        }
      });
    }
    
    // Also handle errors globally
    return next.handle(request).pipe(tap({
      next: (event: HttpEvent<any>) => {

        if (event instanceof HttpErrorResponse) {

        }
        if (event instanceof HttpResponse) {

          // do stuff with response if you want

          
          if (isAPIRequest
            && this.authService.isSignedIn()
            && !request.url.startsWith(environment.webApiRoot + '/api/Account/RefreshToken')
            && new Date(this.authService.tokenInfo?.expires_at || 0) < Utils.addMinutes(new Date(), 5)
            && this.authService.tokenInfo?.refresh_token
            && this.authService.tokenInfo?.refresh_expires_at
            && new Date(this.authService.tokenInfo.refresh_expires_at) > new Date() )
          {
            // If we are close to the token expiration, refresh it

            
            const tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') || '{}') as JwTokenModel;
            if (tokenInfo.refresh_token == this.authService.tokenInfo?.refresh_token) {
              // it was already refreshed by another request, so just update the tokenInfo from localStorage
              const refreshingToken = localStorage.getItem('refreshingToken') == this.authService.tokenInfo?.expires_at;
              if (!refreshingToken) {
                localStorage.setItem('refreshingToken', this.authService.tokenInfo!.expires_at!);
                this.authService.getTokenInfo().forEach(token => {
                  console.debug('Token Refreshed', token?.expires_at);
                  localStorage.removeItem('refreshingToken');
                });
              }
            } else if (tokenInfo.refresh_expires_at
              && new Date(tokenInfo.refresh_expires_at) > new Date(this.authService.tokenInfo.refresh_expires_at)) {
              // already refreshed by another request, but localStorage is not updated yet, so just update the tokenInfo from localStorage
              console.debug('Token Already Refreshed', tokenInfo.refresh_expires_at);
              this.authService.tokenInfo$.next(tokenInfo);
            }
          }
          if (!environment.production && isAPIRequest) {
            try {
              const miniProfilerIds = event.headers.get('X-MiniProfiler-Ids');
              if (miniProfilerIds) {
                this.profiler.fetch(JSON.parse(miniProfilerIds));
              }
            } catch (err) { }
          }
        }
      },
      error: err => {
        // Handle this err
        //console.error(err, request.url);
                
      }
    }),
      catchError(err => {
        if (err.status === 401) {
          console.error('Unauthorized request ' + request.url + ' signing out');
          //this.authService.signOut();
          this.router.navigate(['/signin']);
        }
        const errorMsg = Utils.getAjaxError(err);

        if (err.error && err.error.error)
          console.error(request.url, err.error.error);
        else if (err.error && err.error.Details)
          console.error(request.url, err.error.Details);
        else
          console.error(request.url, errorMsg);

        return throwError({ Message: errorMsg });
      })
    );

  }
}
